import * as React from 'react'
import { TextField, DateField, CreateButton, TopToolbar, EditButton, FilterButton } from 'react-admin'
import { makeStyles } from '@material-ui/styles'
import { CustomList } from 'components/CustomList'
import { CustomDatagrid } from 'components/CustomDatagrid'
import { Children, cloneElement } from 'react'
import HostInstitutionItemActionMenu from './HostInstitutionActionMenu'
import hostInstitutionFilters from './HostInstitutionFilters'

const useStyles = makeStyles({
  editButton: {
    '& span': {
      color: '#BCB5B9',
    },
    '& span .RaButton-label-7': {
      display: 'none',
    },
  },
  toolbar: {
    display: 'flex',
  },
  filters: {
    '& form': {
      margin: '0 0 24px 0',
      width: '80%',
      paddingTop: '24px',
      '& div': {
        maxWidth: '630px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'right',
      },
      '& [class*="RaFilterFormInput-spacer"]': {
        display: 'none',
      },
    },
    '& .search-query-input': {
      maxWidth: '555px',
    },
  },
})

type HostInstitutionEditButtonProps = { record?: any }

const HostInstitutionEditButton: React.FC<HostInstitutionEditButtonProps> = ({ record }) => {
  const classes = useStyles()
  return <EditButton basePath="/host_institutions" className={classes.editButton} label="Edit" record={record} />
}

const ListActions: React.FC = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton variant="contained" color="primary" />
  </TopToolbar>
)

const ListActionToolbar = ({ children, ...props }) => {
  const classes = useStyles()
  return <div className={classes.toolbar}>{Children.map(children, button => cloneElement(button, props))}</div>
}

const HostInstitutionList: React.FC = props => {
  const classes = useStyles()
  return (
    <CustomList
      {...props}
      className={classes.filters}
      filters={hostInstitutionFilters}
      actions={<ListActions />}
      bulkActionButtons={false}
    >
      <CustomDatagrid resource="host_institutions" {...props} showSelectCheckboxes={false}>
        <TextField label="University" source="name" />
        <TextField label="Country" source="country.name" />
        <DateField label="Created Date" source="created_at" />
        <DateField label="Last Updated" source="updated_at" />
        <TextField label="Updated By" source="updated_by" />
        <ListActionToolbar label="Actions">
          <HostInstitutionEditButton />
          <HostInstitutionItemActionMenu {...props} />
        </ListActionToolbar>
      </CustomDatagrid>
    </CustomList>
  )
}

export default HostInstitutionList
